import React from 'react';
export const TransitionHookSection = () => {
  return <section className="bg-familia-dark py-12 md:py-20 px-4 md:px-6" data-id="element-262" data-mp="3pizhv349ae8x">
      <div className="max-w-4xl mx-auto text-center w-full" data-id="element-263" data-mp="19anbzy79hshl">
        <h2 className="text-[26px] sm:text-4xl md:text-5xl font-display font-bold text-white mb-6 leading-tight" data-id="element-264" data-mp="unby3pnlxweb">
          No te falta amor ni ganas.{' '}
          <span className="text-familia-accent" data-id="element-265" data-mp="zkaukeuquffo">Te falta un plan.</span>
        </h2>
        <p className="text-body text-familia-onDarkMuted max-w-2xl mx-auto" data-id="element-266" data-mp="llksekt2hpkg">
          Y armarlo desde cero te lleva horas que no tenés.{' '}
          <span className="text-white font-bold" data-id="element-267" data-mp="bo6gmyi39oyh">
            Eso es exactamente lo que resuelve Vitalidad 360.
          </span>
        </p>
      </div>
    </section>;
};